
(function(){
  if(window.__sjwCG)return; window.__sjwCG=1;
  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return [].slice.call((c||document).querySelectorAll(s));}

  /* ---- shape silhouettes (shared with the birthstone layer) ---- */
  var SHAPES={
    round:'M 12.00 0.80 C 18.19 0.80 23.20 5.81 23.20 12.00 C 23.20 18.19 18.19 23.20 12.00 23.20 C 5.81 23.20 0.80 18.19 0.80 12.00 C 0.80 5.81 5.81 0.80 12.00 0.80 Z',
    oval:'M 12.00 0.90 C 16.42 0.90 20.00 5.87 20.00 12.00 C 20.00 18.13 16.42 23.10 12.00 23.10 C 7.58 23.10 4.00 18.13 4.00 12.00 C 4.00 5.87 7.58 0.90 12.00 0.90 Z',
    cushion:'M 12.00 1.50 C 15.60 1.50 19.00 2.40 20.30 3.70 C 21.60 5.00 22.50 8.40 22.50 12.00 C 22.50 15.60 21.60 19.00 20.30 20.30 C 19.00 21.60 15.60 22.50 12.00 22.50 C 8.40 22.50 5.00 21.60 3.70 20.30 C 2.40 19.00 1.50 15.60 1.50 12.00 C 1.50 8.40 2.40 5.00 3.70 3.70 C 5.00 2.40 8.40 1.50 12.00 1.50 Z',
    princess:'M 2.00 2.00 L 22.00 2.00 L 22.00 22.00 L 2.00 22.00 Z',
    emerald:'M 7.75 1 L 16.25 1 L 20.75 5.5 L 20.75 18.5 L 16.25 23 L 7.75 23 L 3.25 18.5 L 3.25 5.5 Z',
    pear:'M 12 1 C 15.5 4.5 20.25 9 20.25 14.75 C 20.25 19.31 16.56 23 12 23 C 7.44 23 3.75 19.31 3.75 14.75 C 3.75 9 8.5 4.5 12 1 Z',
    marquise:'M 12 1 A 13.03 13.03 0 0 1 12 23 A 13.03 13.03 0 0 1 12 1 Z',
    heart:'M 12 7.8 C 12.9 4.4 13.85 1.2 17 1.2 C 20.15 1.2 22.7 3.75 22.7 6.9 C 22.7 12.4 14.8 19.5 12 22.8 C 9.2 19.5 1.3 12.4 1.3 6.9 C 1.3 3.75 3.85 1.2 7 1.2 C 10.15 1.2 11.1 4.4 12 7.8 Z'
  };
  var TITLE=(document.title||'')+' '+((document.querySelector('h1')||{}).textContent||'');
  function shapeKey(){
    var t=TITLE.toLowerCase();
    var order=['oval','cushion','princess','pear','marquise','heart','asscher','radiant','round'];
    if(/emerald\s*cut|emerald\s*lab/.test(t))return 'emerald';
    for(var i=0;i<order.length;i++){if(t.indexOf(order[i])>-1)return (order[i]==='asscher'||order[i]==='radiant')?'emerald':order[i];}
    return 'round';
  }
  /* face-up aspect (h/w) per cut so mm width maps honestly */
  var ASPECT={round:1,oval:1.38,cushion:1.05,princess:1,emerald:1.4,pear:1.5,marquise:2,heart:1.05};

  /* ---- read the PDP carat chips ---- */
  function readStops(){
    return $$('.sjwpp-dg .sjwpp-d').map(function(el){
      var txt=(el.textContent||'').replace(/\s+/g,' ');
      var ct=parseFloat((el.getAttribute('data-val')||'').replace(/[^0-9.]/g,''))||0;
      var mmM=txt.match(/([\d.]+)\s*[×x]\s*([\d.]+)\s*mm/i);
      var mm1=mmM?null:txt.match(/([\d.]+)\s*mm/i); /* round cuts list one measurement */
      return {el:el,val:el.getAttribute('data-val')||'',ct:ct,
        mmW:mmM?parseFloat(mmM[1]):(mm1?parseFloat(mm1[1]):0),
        mmH:mmM?parseFloat(mmM[2]):(mm1?parseFloat(mm1[1]):0),
        mmTxt:mmM?(mmM[1]+'×'+mmM[2]+' mm'):(mm1?(mm1[1]+' mm'):''),
        photos:/in the photos/i.test(txt),
        sel:/\bon\b/.test(el.className)};
    }).filter(function(s){return s.ct>0;});
  }

  /* ---- variant prices: option axis matched to chip values ---- */
  var VARS=null,CARAT_IX=-1,FIXED=null;
  function refreshFixed(){
    var idInp=$('.sjwpp-card [data-sjwpp-id], .sjwpp-card [name="id"], form[action*="/cart/add"] [name="id"]');
    var cur=(idInp&&VARS)?VARS.filter(function(v){return String(v.id)===String(idInp.value);})[0]:null;
    FIXED=cur?cur.options:null;
  }
  function loadPrices(stops,done){
    if(VARS){refreshFixed();done();return;}
    fetch(location.pathname.split('?')[0]+'.js').then(function(r){return r.json();}).then(function(p){
      VARS=p.variants||[];
      var vals=stops.map(function(s){return s.val.toLowerCase();});
      for(var ix=0;ix<3;ix++){
        var hit=VARS.some(function(v){var o=(v.options[ix]||'').toLowerCase();return vals.indexOf(o)>-1;});
        if(hit){CARAT_IX=ix;break;}
      }
      refreshFixed();
      done();
    }).catch(function(){VARS=[];done();});
  }
  function priceFor(stop){
    if(!VARS||CARAT_IX<0)return null;
    var m=VARS.filter(function(v){
      if((v.options[CARAT_IX]||'').toLowerCase()!==stop.val.toLowerCase())return false;
      if(!FIXED)return true;
      for(var i=0;i<3;i++){if(i!==CARAT_IX&&FIXED[i]&&v.options[i]!==FIXED[i])return false;}
      return true;
    })[0];
    return m?m.price:null;
  }
  function money(c){
    if(window.SJW_CUR&&window.SJW_CUR.on)return window.SJW_CUR.money(c);
    c=Number(c)||0;
    return '$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:(c%100?2:0),maximumFractionDigits:2});
  }

  /* ---- metal tint from the PDP metal label ---- */
  function metalTint(){
    var lab=$$('.sjwpp-l').map(function(l){return l.textContent||'';}).join(' ').toLowerCase();
    if(lab.indexOf('rose')>-1)return ['#E8AC96','#A5705B'];
    if(lab.indexOf('yellow')>-1)return ['#E7C260','#8F6B25'];
    if(lab.indexOf('white gold')>-1||lab.indexOf('platinum')>-1||lab.indexOf('silver')>-1)return ['#E9E9E6','#9C9C96'];
    return ['#E7C260','#8F6B25'];
  }

  /* ---- fine-line hand (ink contour on bone) ---- */
  var RFX=176, RFY=151; /* calibrated ring site on the photo */
  /* photo stage: the couple hands photo the merchant chose (Unsplash, uploaded to store Files),
     already B&W; the ring overlay stays full colour. Calibrated: old pearl ring hidden by a soft
     retouch patch, our ring at (170,149), finger axis 18deg, finger width 84 units ~= 16.5mm. */
  var PHOTO='https://cdn.shopify.com/s/files/1/1035/3033/2320/files/sjw-hand-bare.jpg?v=1783358707&width=960';
  var IMG_S=0.30, IMG_X=-2, IMG_Y=-40, ROT=76, FW=61;
  function handSVG(){
    var s='<defs>';
    s+='<filter id="cg-b2" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="2"/></filter>';
    s+='<filter id="cg-b4" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="4.5"/></filter>';
    s+='</defs>';
    s+='<rect x="0" y="0" width="360" height="241" fill="#141414"/>';
    s+='<image href="'+PHOTO+'" x="'+IMG_X+'" y="'+IMG_Y+'" width="'+(1400*IMG_S)+'" height="'+(937*IMG_S)+'"/>';
    return s;
  }
  function stoneSVG(shape,mmA,mmB,tint){
    /* long axis runs along the finger; first mm number is the length */
    var PXMM=FW/16.5;
    var mmL=Math.max(mmA||6.5,mmB||6.5),mmS=Math.min(mmA||6.5,mmB||6.5);
    var h=mmL*PXMM,w=mmS*PXMM; /* h = along finger (local Y), w = across (local X) */
    if(shape==='round'||shape==='princess'||shape==='cushion'||shape==='heart'){w=mmS*PXMM;h=w*(ASPECT[shape]||1);}
    var e=FW/2-1.5;               /* finger edge in local X */
    var si=Math.max(8,w/2-2);     /* band emerges from under the stone */
    var s='<g transform="translate('+RFX+','+RFY+') rotate('+ROT+')">';
    /* worn band: symmetric segments over the finger, ending exactly at its edges */
    function seg(sign){
      var a=sign*si, b=sign*e, mid=sign*(si+e)/2;
      var o='';
      o+='<path d="M '+a+' 2 Q '+mid+' 4.6 '+b+' 2.2" fill="none" stroke="#0d0d0d" stroke-width="4.6" stroke-linecap="round" opacity=".3" filter="url(#cg-b2)" transform="translate(1.2,1.8)"/>';
      o+='<path d="M '+a+' 1 Q '+mid+' 3.6 '+b+' 1.4" fill="none" stroke="'+tint[1]+'" stroke-width="4.2" stroke-linecap="round"/>';
      o+='<path d="M '+a+' 0.4 Q '+mid+' 2.6 '+b+' 0.8" fill="none" stroke="'+tint[0]+'" stroke-width="1.8" stroke-linecap="round" opacity=".95"/>';
      o+='<path d="M '+(a+sign*3)+' 1.6 Q '+mid+' 3.4 '+(b-sign*3)+' 1.8" fill="none" stroke="#FFFDF4" stroke-width=".8" stroke-linecap="round" opacity=".7"/>';
      o+='<circle cx="'+b+'" cy="1.2" r="2.6" fill="#0d0d0d" opacity=".28" filter="url(#cg-b2)"/>';
      return o;
    }
    s+=seg(1)+seg(-1);
    /* stone shadow + soft glow + stone (long axis along the finger) */
    s+='<ellipse cx="1.5" cy="2.6" rx="'+(w/2+4)+'" ry="4.2" fill="#0d0d0d" opacity=".32" filter="url(#cg-b2)"/>';
    s+='<ellipse cx="0" cy="0" rx="'+(w/2+3)+'" ry="'+(h/2+3)+'" fill="#FFFFFF" opacity=".24" filter="url(#cg-b2)"/>';
    var scX=w/24, scY=h/24;
    s+='<g transform="translate('+(-w/2)+','+(-h/2)+') scale('+scX.toFixed(3)+','+scY.toFixed(3)+')">';
    s+='<path d="'+SHAPES[shape]+'" fill="#DCEBF1" stroke="#7FA0AE" stroke-width="'+(1.15/Math.max(scX,0.4)).toFixed(2)+'"/>';
    s+='<path d="'+SHAPES[shape]+'" transform="translate(12 12) scale(.62) translate(-12 -12)" fill="#F1F9FC" opacity=".9"/>';
    s+='<path d="'+SHAPES[shape]+'" transform="translate(12 12) scale(.38) translate(-12 -12)" fill="#FFFFFF"/>';
    s+='<circle cx="9.2" cy="8.2" r="1.5" fill="#fff" opacity=".9"/>';
    s+='</g>';
    var pr=Math.max(1.4,w*0.06);
    [[-0.62,-0.62],[0.62,-0.62],[-0.62,0.62],[0.62,0.62]].forEach(function(o2){
      s+='<circle cx="'+(o2[0]*w/2)+'" cy="'+(o2[1]*h/2)+'" r="'+pr.toFixed(1)+'" fill="'+tint[0]+'" stroke="'+tint[1]+'" stroke-width=".5"/>';
    });
    s+='</g>';
    return s;
  }
  /* ---- modal ---- */
  var stops=[],cur=null,view=null,shape='round';
  var ov,card,scene,ctEl,mmEl,badgeEl,priceEl,deltaEl,railEl,ctaEl,guideEl;
  function build(){
    if(ov)return;
    ov=document.createElement('div');ov.className='sjw-cg-ov';
    card=document.createElement('div');card.className='sjw-cg';card.setAttribute('role','dialog');card.setAttribute('aria-modal','true');card.setAttribute('aria-label','Diamond size guide');
    card.innerHTML=
      '<div class="sjw-cg-hd">'+
        '<p class="sjw-cg-eye">Diamond guide</p>'+
        '<h4 class="sjw-cg-tt">Center diamond &middot; <em id="sjw-cg-shape"></em></h4>'+
        '<button type="button" class="sjw-cg-x" aria-label="Close">&#x2715;</button>'+
      '</div>'+
      '<div class="sjw-cg-bd">'+
        '<div class="sjw-cg-stage"><svg id="sjw-cg-scene" viewBox="0 0 360 241" preserveAspectRatio="xMidYMid slice" role="img" aria-label="This diamond shown on a hand"></svg></div>'+
        '<p class="sjw-cg-scale">Shown in proportion &middot; average hand</p>'+
        '<div class="sjw-cg-read">'+
          '<div class="sjw-cg-col">'+
            '<p class="sjw-cg-lab">Center diamond</p>'+
            '<div class="v">'+
              '<span class="sjw-cg-ct" id="sjw-cg-ct"></span>'+
              '<span class="sjw-cg-mm" id="sjw-cg-mm"></span>'+
              '<span class="sjw-cg-badge" id="sjw-cg-badge" style="display:none">In the photos</span>'+
            '</div>'+
          '</div>'+
          '<span class="sjw-cg-price"><span class="k">Complete ring</span><span class="p" id="sjw-cg-price"></span><span class="d" id="sjw-cg-delta"></span></span>'+
        '</div>'+
        '<div class="sjw-cg-railwrap" id="sjw-cg-railwrap"><button type="button" class="sjw-cg-prev" aria-label="Show previous diamond sizes">&#8249;</button><div class="sjw-cg-rail" id="sjw-cg-rail"></div><button type="button" class="sjw-cg-more" aria-label="Show more diamond sizes">&#8250;</button></div>'+
        '<p class="sjw-cg-edu">Carat is weight, not width &mdash; doubling the carats makes a stone only about a quarter wider.</p>'+
        '<details class="sjw-cg-guide" id="sjw-cg-guide-w"><summary>All sizes &amp; measurements</summary><div id="sjw-cg-guide"></div></details>'+
      '</div>'+
      '<div class="sjw-cg-ft">'+
        '<button type="button" class="sjw-cg-cta" id="sjw-cg-cta"></button>'+
        '<p class="sjw-cg-note">Every price shown is for the complete ring &mdash; your diamond, setting and band in the selected metal.</p>'+
        '<p class="sjw-cg-glink"><a href="/pages/diamond-stone-guide" target="_blank" rel="noopener">Learn more in our Diamond &amp; Stone Guide &rarr;</a></p>'+
      '</div>';
    document.body.appendChild(ov);document.body.appendChild(card);
    scene=$('#sjw-cg-scene',card);ctEl=$('#sjw-cg-ct',card);mmEl=$('#sjw-cg-mm',card);badgeEl=$('#sjw-cg-badge',card);
    priceEl=$('#sjw-cg-price',card);deltaEl=$('#sjw-cg-delta',card);railEl=$('#sjw-cg-rail',card);ctaEl=$('#sjw-cg-cta',card);guideEl=$('#sjw-cg-guide',card);
    $('.sjw-cg-x',card).addEventListener('click',close);
    ov.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    ctaEl.addEventListener('click',function(){
      if(view&&view.el){view.el.click();}
      close();
    });
    var rw=$('#sjw-cg-railwrap',card);
    var prev=$('.sjw-cg-prev',rw);
    var more=$('.sjw-cg-more',rw);
    function railHint(){
      if(!rw)return;
      var atStart=railEl.scrollLeft<4;
      var atEnd=railEl.scrollLeft+railEl.clientWidth>=railEl.scrollWidth-4;
      rw.classList.toggle('start',atStart);
      rw.classList.toggle('end',atEnd);
      if(prev)prev.disabled=atStart;
      if(more)more.disabled=atEnd;
    }
    railEl.addEventListener('scroll',railHint,{passive:true});
    function moveRail(direction){
      var first=railEl.querySelector('.sjw-cg-stop');
      var cardW=first?first.offsetWidth+8:84;
      var step=Math.max(1,Math.floor(railEl.clientWidth/cardW)-1);
      var current=Math.max(0,stops.indexOf(view));
      var next=Math.max(0,Math.min(stops.length-1,current+(direction*step)));
      var target=railEl.children[next];
      view=stops[next];render();
      var fallback=direction*Math.max(cardW,Math.round(railEl.clientWidth*.72));
      var left=target?target.offsetLeft-(railEl.clientWidth-target.offsetWidth)/2:railEl.scrollLeft+fallback;
      railEl.scrollLeft=Math.max(0,Math.min(railEl.scrollWidth-railEl.clientWidth,left));
      railHint();
    }
    if(prev)prev.addEventListener('click',function(){moveRail(-1);});
    if(more)more.addEventListener('click',function(){moveRail(1);});
    window.__cgRailHint=railHint;
  }
  var scrollY=0,legacyLocked=false,closing=false;
  var hidChat=[];
  function hideOverlays(){
    hidChat=[];
    $$('#ShopifyChat,#dummy-chat-button-iframe,.sjw-jewel').forEach(function(el){
      hidChat.push([el,el.style.visibility]);
      el.style.setProperty('visibility','hidden','important');
    });
  }
  function showOverlays(){
    hidChat.forEach(function(p){p[0].style.visibility=p[1]||'';});
    hidChat=[];
  }
  function lock(opener){
    hideOverlays();
    if(window.SJW_PDP_MODAL){window.SJW_PDP_MODAL.lock('diamond-guide',$('.sjw-cg-bd',card)||card,opener,card);return;}
    if(legacyLocked)return;legacyLocked=true;scrollY=window.scrollY;document.body.style.position='fixed';document.body.style.top=(-scrollY)+'px';document.body.style.width='100%';
  }
  function unlock(){
    if(window.SJW_PDP_MODAL)window.SJW_PDP_MODAL.unlock('diamond-guide');
    else if(legacyLocked){legacyLocked=false;document.body.style.position='';document.body.style.top='';document.body.style.width='';window.scrollTo(0,scrollY);}
    showOverlays();
  }
  function close(){if(!ov||closing||ov.style.display==='none')return;closing=true;ov.classList.remove('show');card.classList.remove('show');setTimeout(function(){ov.style.display='none';card.style.display='none';unlock();closing=false;},340);}

  function render(){
    $('#sjw-cg-shape',card).textContent=shape.charAt(0).toUpperCase()+shape.slice(1)+(shape==='round'?' brilliant':' cut');
    var tint=metalTint();
    scene.innerHTML=handSVG()+stoneSVG(shape,view.mmW||6.5,view.mmH||6.5,tint);
    ctEl.textContent=view.val;
    mmEl.textContent=view.mmTxt;
    var anyP=stops.some(function(s){return s.photos;});
    badgeEl.style.display=anyP?'':'none';
    badgeEl.style.visibility=view.photos?'':'hidden';
    var p=priceFor(view),pc=cur?priceFor(cur):null;
    priceEl.textContent=p!=null?money(p):'';
    if(p!=null&&pc!=null&&view!==cur){
      var d=p-pc;
      deltaEl.textContent=(d>=0?'+ ':'− ')+money(Math.abs(d))+' from your selection';
      deltaEl.className='d'+(d>0?' up':'');
      deltaEl.style.display='';
    }else{deltaEl.textContent=' ';deltaEl.className='d';deltaEl.style.display='';}
    ctaEl.textContent=(view===cur?'Keep ':'Choose ')+view.val+(p!=null?' — '+money(p):'');
    $$('.sjw-cg-stop',railEl).forEach(function(b,i){b.classList.toggle('on',stops[i]===view);});
  }
  function buildRail(){
    railEl.innerHTML='';
    stops.forEach(function(s){
      var b=document.createElement('button');b.type='button';b.className='sjw-cg-stop';
      var p=priceFor(s);
      b.innerHTML='<span class="c">'+s.val+'</span><span class="p">'+(p!=null?money(p):'&nbsp;')+'</span>'+(s.photos?'<span class="b">In the photos</span>':'');
      b.addEventListener('click',function(){view=s;render();});
      railEl.appendChild(b);
    });
  }
  function buildGuide(){
    guideEl.innerHTML='';
    var maxW=Math.max.apply(null,stops.map(function(s){return s.mmW||1;}));
    stops.forEach(function(s){
      var r=document.createElement('div');r.className='sjw-cg-grow';
      var w=(s.mmW||6)*2.1,h=(s.mmH||6)*2.1;
      var box=Math.ceil(maxW*2.1)+2;
      var p=priceFor(s);
      r.innerHTML='<svg viewBox="0 0 24 24" width="'+w+'" height="'+h+'" style="margin:0 '+(((box-w)/2)+2)+'px"><path d="'+SHAPES[shape]+'" fill="#EDF5F8" stroke="#9DB4BE" stroke-width="1"/><path d="'+SHAPES[shape]+'" transform="translate(12 12) scale(.58) translate(-12 -12)" fill="#fff" opacity=".95"/></svg>'+
        '<span class="gc">'+s.val+'</span><span class="gm">'+s.mmTxt+'</span>'+(s.photos?'<span class="gb">In the photos</span>':'')+
        '<span class="gp">'+(p!=null?money(p):'')+'</span>';
      r.addEventListener('click',function(){view=s;render();});
      guideEl.appendChild(r);
    });
  }
  function open(opener){
    if(closing)return false;
    stops=readStops();
    if(!stops.length)return false;
    shape=shapeKey();
    cur=stops.filter(function(s){return s.sel;})[0]||stops.filter(function(s){return s.photos;})[0]||stops[0];
    view=cur;
    build();
    loadPrices(stops,function(){
      buildRail();buildGuide();render();
      var onEl=$('.sjw-cg-stop.on',railEl);if(onEl){
        railEl.scrollLeft=Math.max(0,onEl.offsetLeft-(railEl.clientWidth-onEl.offsetWidth)/2);
      }
      if(window.__cgRailHint)setTimeout(window.__cgRailHint,80);
    });
    buildRail();render();
    if(window.__cgRailHint)setTimeout(window.__cgRailHint,60);
    ov.style.display='block';card.style.display='flex';
    lock(opener);
    requestAnimationFrame(function(){ov.classList.add('show');card.classList.add('show');});
    return true;
  }

  document.addEventListener('sjw:currency',function(){
    if(!ov||!view||ov.style.display==='none')return;
    buildRail();buildGuide();render();
    if(window.__cgRailHint)setTimeout(window.__cgRailHint,0);
  });

  /* intercept the compiled "Diamond Guide" trigger */
  document.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('.sjwpp-findbtn'):null;
    if(!b)return;
    if(!/diamond guide/i.test(b.textContent||''))return;
    if(!$('.sjwpp-dg .sjwpp-d'))return;
    e.preventDefault();e.stopImmediatePropagation();e.stopPropagation();
    open(b);
  },true);
})();
